<template>
  <div>
    <el-button type="text" @click="zhuce">注册</el-button>
    <el-dialog
      title="注册"
      :visible.sync="dialogVisible"
      width="50%"
      height="500px"
      :before-close="handleClose"
      append-to-body
    >
      <font color="red">
        <span v-if="yanzheng">{{yanzhengtishi}}</span>
      </font>
      <el-form label-width="80px">
        <el-form-item label="用户名">
          <el-input type="text" v-model="username" />
        </el-form-item>
        <el-form-item label="密码">
          <el-input type="password" v-model="password" />
        </el-form-item>
        <el-form-item label="确认密码">
          <el-input type="password" v-model="password1" />
        </el-form-item>
        <el-form-item label="邮箱">
          <el-input type="mail" id="email" v-model="email" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="loginsubmit()" :disabled="jinyong">确 定</el-button>
        <el-button @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dialogVisible: false,
      username: "",
      password: "",
      password1: "",
      email: "",
      yanzhengtishi: "",
      yanzheng: false,
      jinyong: false,
    };
  },
  methods: {
    handleClose(done) {
      this.$confirm("确定关闭吗")
        .then(() => {
          // function(done)，done 用于关闭 Dialog
          done();
        })
        .catch(() => {});
    },
    zhuce() {
      this.dialogVisible = true;
    },
    loginsubmit() {
      var _this = this;
      if (this.username.length <= 0) {
        return this.$message({
          message: "用户名不能为空",
          type: "error",
        });
      }
      if (this.password.length <= 0) {
        return this.$message({
          message: "密码不能为空",
          type: "error",
        });
      }
      if (this.email.length <= 0) {
        return this.$message({
          message: "邮箱不能为空",
          type: "error",
        });
      }
      if (this.password != this.password1) {
        return this.$message({
          message: "两次密码不一致",
          type: "error",
        });
      }
      let formData = new FormData();
      formData.append("userName", this.username);
      formData.append("password", this.password);
      formData.append("email", this.email);
      this.jinyong = true;
      this.$axios.defaults.withCredentials = true;
      this.$axios
        .post(this.$getaxiosurl("/register"), formData)
        .then(function (res) {
          if (res.data.code == "00100") {
            _this.dialogVisible = false;
          }
          if (res.data.code != "00100") {
            _this.yanzheng = true;
            _this.yanzhengtishi = res.data.msg;
          }
        });
    },
  },
};
</script>
<style scoped>
input {
  width: 30%;
  height: 25px;
  margin-top: 20px;
  font-size: 14px;
  padding: 0px;
  border: 1px solid;
  border-color: #c9c9c9 #dfdfdf #dfdfdf #c9c9c9;
}
</style>